import { render, staticRenderFns } from "./ContentSidebarLinks.vue?vue&type=template&id=37ef1665&scoped=true&"
import script from "./ContentSidebarLinks.vue?vue&type=script&lang=js&"
export * from "./ContentSidebarLinks.vue?vue&type=script&lang=js&"
import style0 from "./ContentSidebarLinks.vue?vue&type=style&index=0&id=37ef1665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef1665",
  null
  
)

export default component.exports